"use strict";

angular.module('app.schedule.scheduleGame.scheduleGameController', [])
    .controller('app.schedule.scheduleGame.scheduleGameController', [
        '$scope',
        'PRODUCT',
        function ($scope, product) {
            $scope.game = $scope.game || null;
            $scope.layout = $scope.layout || null;
            $scope.isCollapsed = !!$scope.isCollapsed;
            $scope.productId = product.Id;

            $scope.game_status_icon_class = function (game) {
                if (game.is_blacked_out) {
                    return 'schedule-vod-div-class-red';
                } else {
                    if (game.blivegameflag === 2) {
                        if (game.currently_streaming === true) {
                            return 'schedule-vod-div-class-green';
                        } else {
                            return 'schedule-vod-div-class-none'
                        }
                    } else if (game.blivegameflag > 2) {
                        return 'schedule-vod-div-class-red';
                    } else {
                        return 'schedule-vod-div-class-blue';
                    }
                }
            };
            $scope.game_status_message = function (game) {
                if (game.is_blacked_out) {
                    return 'Blacked out in your area';
                } else {
                    switch (game.blivegameflag) {
                        case 2:
                            return 'Scheduled to be live';
                        case 3:
                            return 'Venue canceled broadcast';
                        case 4:
                            return 'Venue does not broadcast';
                        case 5:
                            return 'Game not broadcast on HockeyTV';
                        case 6:
                            return 'Game canceled by team';
                        case 7:
                            return 'Available on TSN or TSN2';
                        case 8:
                            return 'No Internet available';
                        case 9:
                            return 'Game postponed';
                        default:
                            return '';
                    }
                }
            };
            $scope.game_status_label = function (game) {
                if (game.is_blacked_out) {
                    return 'blacked-out';
                } else if (game.blivegameflag === 2 && game.currently_streaming === true) {
                    return 'live';
                } else if (game.blivegameflag > 2) {
                    return 'cancelled';
                } else if (game.blivegameflag <= 0) {
                    return 'vod';
                }
            };
        }
    ]);


// WEBPACK FOOTER //
// ./app.v2/components/schedule/scheduleGame/scheduleGameController.js